export { default } from './FeaturedBullets';
